import * as React from 'react';

export const PageWrapperContext = React.createContext('pageContainer');
